import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
type Slide = {
  image: string;
  tag: string;
  title: string;
  description: string;
};
const slides: Slide[] = [{
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/48bfadda-b3c7-46ba-882f-13554076ddf8.jpg',
  tag: 'Moduł 4 · Aktywności',
  title: 'Architektura i detal miejski',
  description: 'Karta pracy prowadzi ucznia od obserwacji budynku po własny projekt elewacji — z gotowymi pytaniami i miejscem na szkic.'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/3949f8c9-9f6d-49d1-8a71-e65b2cb02959.jpg',
  tag: 'Moduł 2 · Karty pracy',
  title: 'Kolor i emocje w obrazie',
  description: 'Koło barw, ćwiczenie z barwami ciepłymi i zimnymi oraz zadanie malarskie do wykonania w klasie.'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/550afa13-7784-4dd2-a152-251686596b28.jpg',
  tag: 'Moduł 7 · Scenariusz',
  title: 'Portret i proporcje twarzy',
  description: 'Scenariusz minuta po minucie z diagramem proporcji i etapami rysowania, gotowy do wyświetlenia lub wydruku.'
}];
export function Preview() {
  const [index, setIndex] = useState(0);
  const slide = slides[index];
  const go = (direction: -1 | 1) => {
    setIndex(prev => (prev + direction + slides.length) % slides.length);
  };
  return <section className="w-full bg-cream" data-id="element-92" data-mp="3lub9dfspjoql">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-93" data-mp="3qu7btalrb841">
        <div className="text-center" data-id="element-94" data-mp="3qsw5p44u9o9r">
          <Eyebrow data-id="element-95" data-mp="3byrft01m9250">Zajrzyj do środka</Eyebrow>
          <h2 className="mt-4 font-display text-[24px] font-bold leading-tight text-ink sm:text-[27px]" data-id="element-96" data-mp="3c02foorxxpqu">
            Zobacz materiały{' '}
            <em className="font-display italic text-coral" data-id="element-97" data-mp="20ib51k10b9oh">od środka.</em>
          </h2>
          <p className="mx-auto mt-3 max-w-md text-[12px] leading-relaxed text-muted" data-id="element-98" data-mp="25hntg97j0ot6">
            Przewijaj strony i przekonaj się, że wszystko jest już
            zaprojektowane, opisane i gotowe do wydruku.
          </p>
        </div>

        <div className="mt-10 grid items-start gap-6 md:grid-cols-[1fr_13rem]" data-id="element-99" data-mp="71ev58zvyyax">
          <div className="relative" data-id="element-100" data-mp="28luaw7jga44">
            <div className="overflow-hidden rounded-xl bg-white p-3 shadow-[0_28px_60px_-38px_rgba(36,28,24,0.5)]" data-id="element-101" data-mp="27j46qi1ibp9">
              <img key={slide.image} src={slide.image} alt={`Podglad materiału: ${slide.title}`} className="w-full rounded-lg" width={1200} height={900} data-id="element-102" data-mp="3tdu6epysdii6" />
            </div>

            <button type="button" onClick={() => go(-1)} aria-label="Poprzedni materiał" className="absolute -left-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-coral text-white shadow-md transition-colors duration-150 ease-out hover:bg-coral-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-coral-dark focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-103" data-mp="3fg5kdeszg5bj">
              <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="1l6gvgwoy0j89" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Następny materiał" className="absolute -right-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-coral text-white shadow-md transition-colors duration-150 ease-out hover:bg-coral-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-coral-dark focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-105" data-mp="1pza3pujme9p3">
              <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-106" data-mp="1c8etadth3kje" />
            </button>
          </div>

          <div data-id="element-107" data-mp="2imnutc0n0b1a">
            <p className="text-[9px] font-semibold uppercase tracking-[0.16em] text-coral" data-id="element-108" data-mp="2in5z8vxgdvka">
              {slide.tag}
            </p>
            <h3 className="mt-2 font-display text-[15px] font-bold leading-snug text-ink" data-id="element-109" data-mp="2l7lr8lnjxj3w">
              {slide.title}
            </h3>
            <p className="mt-2 text-[11px] leading-relaxed text-muted" data-id="element-110" data-mp="2h7bkh6rxqonz">
              {slide.description}
            </p>

            <ul className="mt-4 grid grid-cols-3 gap-2" data-id="element-111" data-mp="2v7cnarrrg663">
              {slides.map((item, itemIndex) => <li key={item.image} data-id="element-112" data-mp="2q91dgh1gtvnv" data-mpi={itemIndex}>
                  <button type="button" onClick={() => setIndex(itemIndex)} aria-label={`Pokaż: ${item.title}`} aria-current={itemIndex === index} className={`block w-full overflow-hidden rounded-md border-2 bg-white transition-colors duration-150 ease-out ${itemIndex === index ? 'border-coral' : 'border-transparent hover:border-coral/40'}`} data-id="element-113" data-mp="3467sq1mzdc8c">
                    <img src={item.image} alt="" className="h-14 w-full object-cover" width={240} height={180} data-id="element-114" data-mp="3itj4o4n2qy8z" />
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}